import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/base'
import '@/plugins/chartist'
import '@/plugins/vee-validate'
import '@/plugins/vue-world-map'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import '@/plugins/vuetify-confirm'
import '@/plugins/tiptap'
import '@/plugins/vue-async-computed'
import 'devextreme/dist/css/dx.common.css'
import print from 'print-js'
import '@/plugins/jquery'
import '@/plugins/jsonEditor'
import '@/plugins/signalr'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  print,
  render: h => h(App),
}).$mount('#app')
